import { render, staticRenderFns } from "./PlayGrid.vue?vue&type=template&id=5808436e&scoped=true"
import script from "./PlayGrid.vue?vue&type=script&lang=js"
export * from "./PlayGrid.vue?vue&type=script&lang=js"
import style0 from "./PlayGrid.vue?vue&type=style&index=0&id=5808436e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5808436e",
  null
  
)

export default component.exports